var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row mb-3" }, [
    _c("div", { staticClass: "col job-tabs" }, [
      _c("div", { staticClass: "mb-4 nav nav-tabs nav-fill" }, [
        _c(
          "div",
          {
            staticClass: "nav-item nav-link pointer",
            class: [_vm.jobTabStep === 1 ? "active" : ""],
            on: {
              click: function($event) {
                _vm.setJobTabStep(1)
              }
            }
          },
          [_vm._v("\n        Addresses\n      ")]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "nav-item nav-link pointer",
            class: [_vm.jobTabStep === 2 ? "active" : ""],
            on: {
              click: function($event) {
                _vm.setJobTabStep(2)
              }
            }
          },
          [_vm._v("\n        Location details\n      ")]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "nav-item nav-link pointer",
            class: [_vm.jobTabStep === 3 ? "active" : ""],
            on: {
              click: function($event) {
                _vm.setJobTabStep(3)
              }
            }
          },
          [_vm._v("\n        Movers & Trucks\n      ")]
        ),
        _vm._v(" "),
        _vm.$_can("jobs.fee.change")
          ? _c(
              "div",
              {
                staticClass: "nav-item nav-link pointer",
                class: [_vm.jobTabStep === 6 ? "active" : ""],
                on: {
                  click: function($event) {
                    _vm.setJobTabStep(6)
                  }
                }
              },
              [_vm._v("\n        Fees & Percentages\n      ")]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.plans.length && _vm.$_can("jobs.plans.index")
          ? _c(
              "div",
              {
                staticClass: "nav-item nav-link pointer",
                class: [_vm.jobTabStep === 5 ? "active" : ""],
                on: {
                  click: function($event) {
                    _vm.setJobTabStep(5)
                  }
                }
              },
              [_vm._v("\n        Plans\n      ")]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.$_can("jobs.logs.index")
          ? _c(
              "div",
              {
                staticClass: "nav-item nav-link pointer",
                class: [_vm.jobTabStep === 4 ? "active" : ""],
                on: {
                  click: function($event) {
                    _vm.setJobTabStep(4)
                  }
                }
              },
              [_vm._v("\n        Log\n      ")]
            )
          : _vm._e()
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-46fe784d", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-46fe784d","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/jobs/JobsTabs.vue
// module id = null
// module chunks = 